<div fxLayout="row" fxLayoutAlign="end center" class="newCashRegister">
  <button
    mat-raised-button
    color="primary"
    class="submit-button w-button"
    (click)="editPointEmission(0, -1)"
  >
    + Nueva caja
  </button>
</div>
<div class="custom-height">
  <table
    *ngIf="dataSource"
    mat-table
    [dataSource]="dataSource!"
    class="mat-elevation-z0"
  >
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item; let i = index">
        <mat-slide-toggle
          [checked]="item.active"
          (change)="switchActive(item.id, i, $event)"
        >
        </mat-slide-toggle>
      </td>
    </ng-container>
    <ng-container matColumnDef="cashRegisterNumber">
      <th mat-header-cell *matHeaderCellDef>Número</th>
      <td
        mat-cell
        class="text-efect"
        *matCellDef="let item; let i = index"
        (click)="editPointEmission(item.id, i)"
      >
        {{ item.number }}
      </td>
    </ng-container>
    <ng-container matColumnDef="cashRegisterName">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td
        mat-cell
        class="text-efect"
        *matCellDef="let item; let i = index"
        (click)="editPointEmission(item.id, i)"
      >
        {{ item.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>Usuario</th>
      <td
        mat-cell
        class="text-efect"
        *matCellDef="let item; let i = index"
        (click)="editPointEmission(item.id, i)"
      >
        {{ item.user }}
      </td>
    </ng-container>
    <ng-container matColumnDef="creationDate">
      <th mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let item">{{ item.creationDate }}</td>
    </ng-container>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Estatus</th>
      <td mat-cell *matCellDef="let item">
        {{ item.active ? 'Activo' : 'Inactivo' }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
